var RootVariable = {
  EMPTY_IMAGE_SIZE: '--gui-empty-image-size',
  EMPTY_IMAGE_GAP: '--gui-empty-image-gap',
  EMPTY_LABEL_FONT_SIZE: '--gui-empty-label-font-size',
  EMPTY_LABEL_FONT_WEIGHT: '--gui-empty-label-font-weight',
  EMPTY_LABEL_COLOR: '--gui-empty-label-color',
  EMPTY_LABEL_GAP: '--gui-empty-label-gap',
  EMPTY_LABEL_LINE_HEIGHT: '--gui-empty-label-line-height'
};

export { RootVariable };
//# sourceMappingURL=constant.js.map
